/**
 * Please, note: this JS was optimized for the old browsers.
 * Change this code carefully.
 */

class ReviewsCarousel extends HTMLElement {
  constructor() {
    super();
    this.initSelectors();
    this.initVariables();
    this.initListeners();
    window.onresize = this.initVariables.bind(this);
  }

  initSelectors() {
    const dots = this.querySelector("[data-dots]");
    const dotsArray = dots.querySelectorAll("[data-dot]");
    this.el = {
      items: this.querySelector("[data-items]"),
      dots: dots,
      dotsArray: dotsArray,
      arrows: this.querySelector("[data-arrows]"),
    }
  }

  initVariables() {
    const reviewCardEl = this.el.items.querySelector(".review-card");
    const reviewCardStyle = getComputedStyle(reviewCardEl);
    const width = Number(reviewCardStyle.width.replace("px", ""));
    const gap = Number(reviewCardStyle.marginRight.replace("px", ""));

    let visibleDotsCount = 0;
    for (let dot of this.el.dotsArray) {
      if (getComputedStyle(dot).display !== "none")
        visibleDotsCount++;
    }

    this.vars = {
      width: width,
      gap: gap,
      outerWidth: width + gap,
      position: 0,
      itemsCount: this.el.items.children.length,
      visibleDotsCount: visibleDotsCount
    }
  }

  initListeners() {
    for (let i = 0; i < this.el.dots.querySelectorAll("[data-dot]").length; i++) {
      this.el.dots.querySelectorAll("[data-dot]")[i].addEventListener("click", () => {
        this.vars.position = i;
        this.scrollToPosition();
        this.el.dots.querySelector(".selected").classList.remove("selected");
        this.el.dots.querySelectorAll("[data-dot]")[i].classList.add("selected");
      });
    }

    for (let i = 0; i < this.el.arrows.querySelectorAll("[data-arrow]").length; i++) {
      this.el.arrows.querySelectorAll("[data-arrow]")[i].addEventListener("click", () => {
        if (i === 0 && this.vars.position > 0)
          this.vars.position--;
        else if (i === 1 && this.vars.position < this.vars.visibleDotsCount - 1)
          this.vars.position++;
        this.scrollToPosition();
        this.activateDot(this.vars.position);
      });
    }

    let scrollActiveTimer = null;
    this.el.items.addEventListener("scroll", () => {
      if(scrollActiveTimer !== null) {
        clearTimeout(scrollActiveTimer);
      }
      scrollActiveTimer = setTimeout(function() {
        this.setPositionBasedOnScroll(this.el.items.scrollLeft);
      }.bind(this), 50);
    })
  }

  activateDot(index) {
    this.el.dots.querySelector(".selected").classList.remove("selected");
    this.el.dotsArray[index].classList.add("selected");
  }

  scrollToPosition() {
    if (!this.el.items.scroll) {
      this.el.items.scrollLeft = this.vars.outerWidth * this.vars.position;
      return;
    }
    this.el.items.scroll({
      left: this.vars.outerWidth * this.vars.position,
      behavior: 'smooth'
    })
  }

  setPositionBasedOnScroll(scrollLeft) {
    this.vars.position = Math.round(scrollLeft / this.vars.outerWidth);
    this.scrollToPosition();
    this.activateDot(this.vars.position);
  }
}

customElements.define('reviews-carousel', ReviewsCarousel);
